import {
  apiClient,
  ApiClientConfig,
  // ApiClientConfig,
  // PaginatedRequestParams,
  // PaginatedResponse,
} from 'api';
import { EventsResponse } from 'features/cms';
// import { axiosInstance } from 'api/axios-instance';
// import { CONFIG } from 'config';
import { listDataType } from 'features/dashboard/components/type';

export const DashboardApiService = () => {

  const getEvents = async (Flag: string) => {
    const response = await apiClient({
      endpoint: `admin/dropdownlist?${Flag}`
    })

    return response.data
  }

  const getDashboardGraphData = async (eventId: number, categoryId: number, Flag: string) => {

    const response = await apiClient<listDataType>({
      endpoint: `admin/dashboard?EventId=${eventId}&SportsCategoryId=${categoryId}&Flag=${Flag}`

    })

    return response.data
  }


  const getDashboardData = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardgraphdata`,
      params,
    });

    return response.data;
  };

  const getDashBoardExecutiveSummary = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/dashboard/executivesummarygraph`,
      params,
    });

    return response.data;
  };
  const getDashBoardCard = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardtopdata`,
      params,
    });

    return response.data;
  };
  const getDashBoardDropDown = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `admin/dashboard/commondropdowndashboardlist`,
      params,
    });

    return response.data;
  };
  const getDashBoardTraget = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/registrationeventbaseddata`,
      params,
    });

    return response.data;
  };
  const getDashBoardTragetPiecircle = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getregistrationcirclegraphdata`,
      params,
    });

    return response.data;
  };
  const getDashBoardregistrationdemographic = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardregistrationdemographicdata`,
      params,
    });

    return response.data;
  };
  const getDashboardcrosssalessummary = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardregistrationcrosssalessummary`,
      params,
    });

    return response.data;
  };
  const getDashboardregistrationcrosssales = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardregistrationcrosssalesgraph`,
      params,
    });

    return response.data;
  };
  const getDashboardshopSales = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardshopsummary`,
      params,
    });

    return response.data;
  };
   const getDashboardshopCategory = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardshopgraphs`,
      params,
    });

    return response.data;
  };
  const getDashboardBooth = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/dashboard/getdashboardboothdata`,
      params,
    });

    return response.data;
  };
  
return {
    getEvents,
    getDashboardGraphData,
    getDashboardData,
    getDashBoardExecutiveSummary,
    getDashBoardCard,
    getDashBoardDropDown,
    getDashBoardTraget,
    getDashBoardTragetPiecircle,
    getDashBoardregistrationdemographic,
    getDashboardcrosssalessummary,
    getDashboardregistrationcrosssales,
    getDashboardshopSales,
    getDashboardshopCategory,
    getDashboardBooth
  };
};



